import { Center, Loader, LoaderProps, LoadingOverlay } from '@mantine/core';

interface ICustomLoader extends LoaderProps {
  overlay?: boolean;
  visible?: boolean;
}

const CustomLoader = (props: ICustomLoader) => {
  if (props.overlay) {
    return (
      <LoadingOverlay
        visible={props.visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 2 }}
        loaderProps={{ color: 'var(--mantine-primary-color-9)', type: 'oval' }}
      />
    )
  }

  return (
    <Center>
      <Loader
        color={'var(--mantine-primary-color-9)'}
        type={'oval'}
        size={32}
        {...props}
      />
    </Center>
  )
}

export default CustomLoader;